function dropdownMenu() {

    jQuery('.dropdown-menu').css('display', 'block');

    var widthDocument = $('html').width();

    $(".navbar-right > .dropdown").each(function () {

        var widthsubmenu = $(this).find('.dropdown-menu .dropdown > .dropdown-menu').outerWidth();

        var offsetLink = $(this).offset().left;

        var ret = widthDocument - offsetLink;

        if (ret < widthsubmenu + 200) {

            $(this).find('.dropdown-menu .dropdown > .dropdown-menu').addClass('left');
            $(this).find('.dropdown-menu .dropdown').addClass('open-left');

        } else {

            $(this).find('.dropdown-menu .dropdown > .dropdown-menu').addClass('right');
            $(this).find('.dropdown-menu .dropdown').addClass('open-right');

        }

    });

    jQuery('.dropdown-menu').css('display', '');

}

jQuery(document).ready(function () {
    dropdownMenu();
});

jQuery(window).resize(function () {
    dropdownMenu();
});